importScripts('https://www.gstatic.com/firebasejs/7.12.0/firebase-app.js');
importScripts('https://www.gstatic.com/firebasejs/7.12.0/firebase-messaging.js');

function isFirebaseSWLoaded() {
    console.log('SW loaded');
}

var firebaseConfig = {
    apiKey: "AIzaSyBzrJKfIx1GTBQXT5I77-oxJ5MDxJ-K6B0",
    authDomain: "agentvizion-a86b1.firebaseapp.com",
    databaseURL: "https://agentvizion-a86b1.firebaseapp.com",
    projectId: "agentvizion-a86b1",
    storageBucket: "agentvizion-a86b1.appspot.com",
    messagingSenderId: "402130589295",
    appId: "1:402130589295:web:a5e0773d70121363e35f9a"
};

firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging();

messaging.setBackgroundMessageHandler(function (payload) {
    console.log('[firebase-messaging-sw.js] Received background message ', payload);
    var obj = JSON.parse(payload.data.notification);
    const notificationTitle = obj.title;
    const notificationOptions = {
        body: obj.body,
        image: obj.image,
    };

    return self.registration.showNotification(notificationTitle,
        notificationOptions);
});